/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/16/22
 */

import React from "react";
import {Stack} from "@mui/material";
import MyCalendars from "./MyCalendars";
import FavoriteCalendars from "./FavoriteCalendars";
import AllCalendars from "./AllCalendars";

export default function Container() {

	return (
		<Stack direction={"row"} spacing={2} sx={{ p: 2 }}>
			<Stack sx={{ width: .4 }} spacing={4}>
				<MyCalendars />
				<FavoriteCalendars />
			</Stack>
			<Stack sx={{ width: .6 }}>
				<AllCalendars />
			</Stack>
		</Stack>
	);

}